import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import Reward from 'images/reward.png';

import styles from './RewardBlock.module.scss';

const RewardBlock: React.FC = () => {
    return (
        <a
            href={AppUrls.REGISTRY}
            target="_blank"
            className={styles.container}
            rel="noopener noreferrer"
            aria-label={t`Награда`}
        >
            <img
                className={styles.image}
                src={Reward}
                alt={t`Награда`}
            />
        </a>
    );
};

export default RewardBlock;